import _max from 'lodash/max'
import _cloneDeep from 'lodash/cloneDeep'
import { MapToContext } from '@utils/objectWithDefault'
import { WroDraftProduct } from './product'

export class WroDraftShippingBoxConfiguration {
  constructor (data) {
    const defaultdata = {
      quantityPerBox: { val: 0, type: Number },
      numberOfBoxes: { val: 0, type: Number },
      length: { val: 0, type: Number },
      width: { val: 0, type: Number },
      height: { val: 0, type: Number },
      weight: {
        val: {
          pounds: { val: 0, type: Number },
          ounces: { val: 0, type: Number }
        },
        type: Object
      }
    }

    MapToContext(this, defaultdata, data)
  }
}

export class WroDraftShippingConfiguration {
  constructor (data) {
    const defaultdata = {
      id: { val: 0, type: Number },
      name: { val: '', type: String },
      lotNumber: { val: '', type: String },
      expirationDate: { val: '', type: String },
      boxConfigurations: { val: [], type: Array, subType: WroDraftShippingBoxConfiguration }
    }

    MapToContext(this, defaultdata, data)
  }

  add () {
    this.boxConfigurations.push(new WroDraftShippingBoxConfiguration())
  }
}

export class WroDraftShippingSkuConfiguration {
  constructor (data) {
    const defaultdata = {
      id: { val: 0, type: Number },
      product: { val: null, type: WroDraftProduct },
      quantityPerBox: { val: 0, type: Number },
      numberOfBoxes: { val: 0, type: Number },
      length: { val: 0, type: Number },
      width: { val: 0, type: Number },
      height: { val: 0, type: Number },
      weight: {
        val: {
          pounds: { val: 0, type: Number },
          ounces: { val: 0, type: Number }
        },
        type: Object
      }
    }

    MapToContext(this, defaultdata, data)
  }
}

export class WroDraftMultiSkuBoxConfiguration {
  constructor (data) {
    const defaultdata = {
      id: { val: 0, type: Number },
      skuConfigurations: { val: [], type: Array, subType: WroDraftShippingSkuConfiguration }
    }

    MapToContext(this, defaultdata, data)
    if (this.skuConfigurations.length === 0) this.skuConfigurations.push(new WroDraftShippingSkuConfiguration())
  }

  addSkuConfiguration (data) {
    const maxId = _max(this.skuConfigurations.map(sc => sc.id))
    let numberOfBoxes
    if (this.skuConfigurations.length > 0) numberOfBoxes = this.skuConfigurations[0].numberOfBoxes
    this.skuConfigurations.push(new WroDraftShippingSkuConfiguration({ numberOfBoxes, ...data, id: maxId + 1 }))
  }

  updateSkuConfiguration (skuConfigId, data) {
    let skuConfig = this.skuConfigurations.find(sc => sc.id === skuConfigId)
    skuConfig = data
    this.skuConfigurations.splice(skuConfigId, 1, skuConfig)
  }

  removeSkuConfigurationById (skuConfigId) {
    const skuConfigurationIndex = this.skuConfigurations.findIndex(sc => sc.id === skuConfigId)
    if (skuConfigurationIndex > -1) this.skuConfigurations.splice(skuConfigurationIndex, 1)
  }

  selectProductForSkuConfigurationById (skuConfigId, product) {
    const skuConfigurationIndex = this.skuConfigurations.findIndex(sc => sc.id === skuConfigId)
    const skuConfigurationOfFirstItem = this.skuConfigurations[0]
    if (skuConfigurationIndex > -1) {
      const copiedConfig = _cloneDeep(this.skuConfigurations[skuConfigurationIndex])
      copiedConfig.product = product
      copiedConfig.quantityPerBox = 0
      copiedConfig.length = skuConfigurationOfFirstItem.length
      copiedConfig.width = skuConfigurationOfFirstItem.width
      copiedConfig.height = skuConfigurationOfFirstItem.height
      copiedConfig.weight.pounds = skuConfigurationOfFirstItem.weight.pounds
      copiedConfig.weight.ounces = skuConfigurationOfFirstItem.weight.ounces
      this.skuConfigurations.splice(skuConfigurationIndex, 1, copiedConfig)
    }
    if (skuConfigurationIndex === 0) {
      this.selectNumberOfBoxesForSkuConfigurationById(skuConfigId, 0)
    }
  }

  selectQuantityForSkuConfigurationById (skuConfigId, value) {
    const skuConfigurationIndex = this.skuConfigurations.findIndex(sc => sc.id === skuConfigId)
    if (skuConfigurationIndex > -1) this.skuConfigurations[skuConfigurationIndex].quantityPerBox = value
  }

  selectNumberOfBoxesForSkuConfigurationById (_skuConfigId, value) {
    this.skuConfigurations.forEach(skuConfig => {
      skuConfig.numberOfBoxes = value
    })
  }
}
